<template>
  <div class="container-fluid">
    <div class="row no-gutter" style="background-color: #ffffff;">
      <div class="d-none d-md-flex col-md-4 col-lg-6 bg-image"></div>
      <div class="col-md-8 col-lg-6">
        <div class="d-flex justify-content-end">


          <small class="text-muted">{{GetVersion()}}</small>
        </div>
        <div class="login d-flex align-items-center py-3">
          <div class="container">
            <div class="row mb-lg-5">
              <div class="col">
                <img style="height: 10em;" :src="getLogo()" class="rounded mx-auto d-block" alt="ultron logo">
              </div>
            </div>
            <div class="row">
              <div class="col-md-9 col-lg-8 mx-auto">
                <!-- <h3 class="login-heading mb-4">{{welcomeText}}</h3> -->
                <slot></slot>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      tenant: function () {
        return this.$store.getters.GetTenant();
      },
      welcomeText: function () {
        return `Welcome ${this.tenant && this.tenant.name || ''}!`;
      }
    },
    methods: {
      getLogo: function () {

        let tenantTemp = this.GetTenant();
        // console.log(tenantTemp);
        if (tenantTemp !== null && tenantTemp !== undefined) {
          return tenantTemp.logo;
        }

        //if null tenant default logo will used
        return '/static/assets/img/ultron-logo.png';
      }
    },
    computed: {
      ...mapGetters([
        'GetVersion', 'GetTenant'])
    }
  }
</script>

<style>
  .bg-image {
    background-image: url(/static/assets/img/login-bg.jpg);
    background-size: cover;
    background-position: 50%;
    opacity: .5;
  }

  .login, .bg-image {
    min-height: 100vh;
  }

  .btn-login {
    font-size: .9rem;
    letter-spacing: .05rem;
    padding: .75rem 1rem;
    border-radius: 2rem;
  }

  .login-text-box {
    border-radius: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Auth.vue